import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

export default angular
  .module("app.directives", [])
  .directive("googleplace", function () {
    return {
      require: "ngModel",
      scope: {
        ngModel: "=",
        details: "=?",
      },
      link: function (scope, element, attrs, model) {
        var options = {
          types: ["establishment", "geocode"],
          componentRestrictions: {country: "USA"},
        };
        if (google) {
          scope.gPlace = new google.maps.places.Autocomplete(element[0], options);
          google.maps.event.addListener(scope.gPlace, "place_changed", function () {
            scope.$apply(function () {
              scope.details = scope.gPlace.getPlace();
              let addr = scope.details.adr_address;
              let addr_final = null;
              if (addr.includes("&#39;")) {
                addr_final = addr.replace("&#39;", "'");
              } else {
                addr_final = addr;
              }
              var adrData = {};
              adrData.adr_address = addr_final;
              adrData.lat = scope.details.geometry.location.lat();
              adrData.lng = scope.details.geometry.location.lng();
              model.$setViewValue(adrData);
            });
          });
        }
      },
    };
  })
  .directive("ngEsc", function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress keyup", function (event) {
        if (event.which === 27) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEsc);
          });
          event.preventDefault();
        }
      });
    };
  })
  .directive("ngPrev", function () {
    return function (scope, element, attrs) {
      element.bind("keydown", function (event) {
        if (event.which === 37) {
          scope.$apply(function () {
            scope.$eval(attrs.ngArrow);
          });
          event.preventDefault();
        }
      });
    };
  })
  .directive("ngNext", function () {
    return function (scope, element, attrs) {
      element.bind("keydown", function (event) {
        if (event.which === 37) {
          scope.$apply(function () {
            scope.$eval(attrs.ngArrow);
          });
          event.preventDefault();
        }
      });
    };
  })
  .directive("contenteditable", function () {
    return {
      require: "ngModel",
      link: function (scope, element, attrs, ngModel) {
        function read() {
          ngModel.$setViewValue(element.html());
        }

        ngModel.$render = function () {
          element.html(ngModel.$viewValue || "");
        };
        element.bind("blur keyup change", function () {
          scope.$apply(read);
        });
      },
    };
  })
  .directive("ngEnter", function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter);
          });
          event.preventDefault();
        }
      });
    };
  })
  .directive("file", function () {
    return {
      require: "ngModel",
      restrict: "A",
      link: function (scope, el, attrs, ngModel) {
        el.bind("change", function (event) {
          var files = event.target.files;
          var file = files[0];
          ngModel.$setViewValue(file);
          scope.$apply();
        });
      },
    };
  })
  .directive("loadscript", function () {
    return function (scope, element, attrs) {
      angular.element('<script src="' + scope.vm.fullGoogleUrl + '"></script>').appendTo(element);
    };
  })
  .directive("loadtrack", function () {
    return function (scope, element, attrs) {
      // REMOVE LOCALYTICS
      // var val = "<script>+function(l, y, t, i, c, s) { l['LocalyticsGlobal'] = i;l[i] = function() { (l[i].q = l[i].q || []).push(arguments) }; l[i].t = +new Date; (s = y.createElement(t)).type = 'text/javascript';s.src = '//web.localytics.com/v3/localytics.min.js';(c = y.getElementsByTagName(t)[0]).parentNode.insertBefore(s, c);ll( 'init', '" + scope.vm.llkey + "', {} );}(window, document, 'script', 'll');</script>";
      // angular.element(val).appendTo(element);
    };
  })
  .directive("setClassWhenAtTop", function ($window) {
    var $win = angular.element($window); // wrap window object as jQuery object
    return {
      restrict: "A",
      link: function (scope, element, attrs) {
        var topClass = attrs.setClassWhenAtTop, // get CSS class from directive's attribute value
          offsetTop = element.offset().top; // get element's offset top relative to document
        $win.on("scroll", function (e) {
          var height = Math.max(document.body.scrollHeight, document.body.offsetHeight);
          if (window.innerHeight + window.pageYOffset >= height) {
            let path = scope.$parent.vm.$location.$$path;
            //console.log(window.innerHeight);
            //console.log(window.pageYOffset);
            //console.log(height);
            if (path.includes("jobs")) {
              //we only want to load more jobs on the jobs page...
              if (scope.$parent.vm.no_more_jobs_with_this_search === false) {
                scope.$parent.vm.loadMoreJobsFromBottom();
              }
            } else {
              //were not going to load more jobs on the profile page or
              //the job details page
            }
          }
          if (topClass === "fix-to-top") {
            if ($win.scrollTop() >= 556) {
              element.addClass(topClass);
            } else {
              element.removeClass(topClass);
            }
          } else if (topClass === "fix-to-top-jobs") {
            if ($win.scrollTop() >= 217) {
              element.addClass(topClass);
            } else {
              element.removeClass(topClass);
            }
          }
        });
      },
    };
  })
  .directive("preventscroll", function () {
    return {
      restrict: "A",
      link: function (scope, element, attrs) {
        element.bind("mousewheel DOMMouseScroll", function (e) {
          console.log(e);
          var e0 = e;
          //var delta = e0.wheelDelta || -e0.detail;
          var delta = e0.originalEvent.wheelDelta || -e0.detail;
          scope.scrollTop += (delta < 0 ? 1 : -1) * 30;
          e.preventDefault();
        });
      },
    };
  })
  .directive("fileReader", function () {
    return {
      scope: {
        fileReader: "=",
      },
      link: function (scope, element) {
        $(element).on("change", function (changeEvent) {
          var files = changeEvent.target.files;
          if (files.length) {
            var r = new FileReader();
            r.onload = function (e) {
              var contents = e.target.result;
              scope.$apply(function () {
                console.log("in the apply");
                console.dir(contents);
                scope.fileReader = contents;
              });
            };

            r.readAsText(files[0]);
          }
        });
      },
    };
  })
  .directive("importSheetJs", function ($parse) {
    return {
      link: function ($scope, $elm, $attrs) {
        // Parse callback function from attribute
        var expressionHandler = $parse($attrs.onSheetLoad);

        // Pass upload event to callback
        $elm.on("change", function (changeEvent) {
          var reader = new FileReader();
          reader.onload = function (e) {
            expressionHandler($scope, {e: e});
          };
          reader.readAsBinaryString(changeEvent.target.files[0]);
        });
      },
    };
  })
  .directive("fbLogin", function ($rootScope) {
    return function (scope, iElement, iAttrs) {
      if (FB) {
        FB.XFBML.parse(iElement[0]);
      }
    };
  })
  .directive("scroll", function () {
    return {
      link: function (scope, element, attrs) {
        element.bind("wheel", function () {
          if (document.activeElement.type === "number" && document.activeElement.classList.contains("noscroll")) {
            if (document.activeElement.classList.contains("hours-edit-1") || document.activeElement.classList.contains("hours-edit-2") || document.activeElement.classList.contains("hours-edit-3") || document.activeElement.classList.contains("hours-edit-4")) {
              document.activeElement.blur();
            } else {
              document.activeElement.blur();
            }
          }
        });
      },
    };
  });



// WEBPACK FOOTER //
// ./client/app/directives/directives.js